module.exports = __webpack_public_path__ + "assets/binggan.66a11d73.svg";